function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMeshsync = function SvgMeshsync(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "meshsync_svg__Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 361 359"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M63.5 113.5a133.13 133.13 0 0 1 94-67.5l-8-46A181.53 181.53 0 0 0 22 91Z",
    style: {
      fill: "#00d3a9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5 247a133.4 133.4 0 0 1-19-69 130.1 130.1 0 0 1 8.5-46.5l-44-16A184.5 184.5 0 0 0 0 178a182.54 182.54 0 0 0 25.5 93Z",
    style: {
      fill: "#00b39f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182 312h-1.5C139 312 102 293 77 263l-36 30a181.18 181.18 0 0 0 139.5 66h2Z",
    style: {
      fill: "#00d3a9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297 244a134.07 134.07 0 0 1-95 66l7.5 46.5a180.18 180.18 0 0 0 128-89.5Z",
    style: {
      fill: "#00b39f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296 110.5a133.46 133.46 0 0 1 18 67.5 128 128 0 0 1-9 48l44 17a184.7 184.7 0 0 0 12-64.5 180.8 180.8 0 0 0-24.5-91Z",
    style: {
      fill: "#00d3a9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.3 17.85h44v67.8h-44z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m261.4 85.65-10.1-10.1 23.8-23.8-23.8-23.8 10.1-10.1 33.9 33.9z",
    style: {
      fill: "#20bdab"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.5 17.85h44v67.8h-44z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m193.6 85.65-10.1-10.1 23.8-23.8-23.8-23.8 10.1-10.1 33.9 33.9z",
    style: {
      fill: "#20bdab"
    }
  }));
};
export { SvgMeshsync as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzNjEgMzU5Ij48dGl0bGU+bWVzaHN5bmM8L3RpdGxlPjxwYXRoIGQ9Ik02My41LDExMy41YTEzMy4xMywxMzMuMTMsMCwwLDEsOTQtNjcuNWwtOC00NkExODEuNTMsMTgxLjUzLDAsMCwwLDIyLDkxWiIgc3R5bGU9ImZpbGw6IzAwZDNhOSIvPjxwYXRoIGQ9Ik02NS41LDI0N2ExMzMuNDIsMTMzLjQyLDAsMCwxLTE5LTY5QTEzMC4xNCwxMzAuMTQsMCwwLDEsNTUsMTMxLjVsLTQ0LTE2QTE4NC41NCwxODQuNTQsMCwwLDAsMCwxNzhhMTgyLjU0LDE4Mi41NCwwLDAsMCwyNS41LDkzWiIgc3R5bGU9ImZpbGw6IzAwYjM5ZiIvPjxwYXRoIGQ9Ik0xODIsMzEyaC0xLjVDMTM5LDMxMiwxMDIsMjkzLDc3LDI2M0w0MSwyOTNhMTgxLjE4LDE4MS4xOCwwLDAsMCwxMzkuNSw2NmgyWiIgc3R5bGU9ImZpbGw6IzAwZDNhOSIvPjxwYXRoIGQ9Ik0yOTcsMjQ0YTEzNC4wNywxMzQuMDcsMCwwLDEtOTUsNjZsNy41LDQ2LjVhMTgwLjE4LDE4MC4xOCwwLDAsMCwxMjgtODkuNVoiIHN0eWxlPSJmaWxsOiMwMGIzOWYiLz48cGF0aCBkPSJNMjk2LDExMC41QTEzMy40NiwxMzMuNDYsMCwwLDEsMzE0LDE3OGExMjgsMTI4LDAsMCwxLTksNDhsNDQsMTdhMTg0LjY2LDE4NC42NiwwLDAsMCwxMi02NC41LDE4MC44LDE4MC44LDAsMCwwLTI0LjUtOTFaIiBzdHlsZT0iZmlsbDojMDBkM2E5Ii8+PHJlY3QgeD0iMjUxLjMiIHk9IjE3Ljg1IiB3aWR0aD0iNDQiIGhlaWdodD0iNjcuOCIgc3R5bGU9ImZpbGw6bm9uZSIvPjxwb2x5Z29uIHBvaW50cz0iMjYxLjQgODUuNjUgMjUxLjMgNzUuNTUgMjc1LjEgNTEuNzUgMjUxLjMgMjcuOTUgMjYxLjQgMTcuODUgMjk1LjMgNTEuNzUgMjYxLjQgODUuNjUiIHN0eWxlPSJmaWxsOiMyMGJkYWIiLz48cmVjdCB4PSIxODMuNSIgeT0iMTcuODUiIHdpZHRoPSI0NCIgaGVpZ2h0PSI2Ny44IiBzdHlsZT0iZmlsbDpub25lIi8+PHBvbHlnb24gcG9pbnRzPSIxOTMuNiA4NS42NSAxODMuNSA3NS41NSAyMDcuMyA1MS43NSAxODMuNSAyNy45NSAxOTMuNiAxNy44NSAyMjcuNSA1MS43NSAxOTMuNiA4NS42NSIgc3R5bGU9ImZpbGw6IzIwYmRhYiIvPjwvc3ZnPg==";